import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Box,
} from "@mui/material";
import { investorApi } from "../api/api";
import { useSelector } from "react-redux";
import GradientButton from "../components/common/GradiantButton";

const ChangePassword = () => {
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const userid = useSelector((state) => state.user.userId);
  const theme = useSelector((data) => data.themeValue.colors);
  const themeMode = useSelector((data) => data.themeValue.theme);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // Clear error on change
    setSuccessMessage(""); // Clear success on typing
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [])

 const handleSubmit = async (e) => {
  e.preventDefault();

  let validationErrors = {};

  // 🔹 Frontend validations
  if (!form.currentPassword) {
    validationErrors.currentPassword = "Current password is required.";
  }

  if (!form.newPassword) {
    validationErrors.newPassword = "New password is required.";
  } else if (form.newPassword.length < 8) {
    validationErrors.newPassword =
      "New password must be at least 8 characters long.";
  }

  if (!form.confirmPassword) {
    validationErrors.confirmPassword = "Please confirm your new password.";
  } else if (form.newPassword !== form.confirmPassword) {
    validationErrors.confirmPassword =
      "New password and confirmation do not match.";
  }

  // 🔹 Stop if validation fails
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    setSuccessMessage("");
    return;
  }

  try {
    const response = await investorApi.updatePassword(userid, {
      currentPassword: form.currentPassword,
      newPassword: form.newPassword,
    });

    if (response.status === 200) {
      setForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setErrors({});
      setSuccessMessage("Password updated successfully.");
    }
  } catch (error) {
    const msg =
      error.response?.data?.message || "Something went wrong. Please try again.";

    // 🔹 Map backend error to correct field
    if (msg.toLowerCase().includes("current")) {
      setErrors({ currentPassword: msg });
    } else if (msg.toLowerCase().includes("8")) {
      setErrors({ newPassword: msg });
    } else {
      setErrors({ confirmPassword: msg });
    }

    setSuccessMessage("");
  }
};


  return (
    <Container
      maxWidth={false}
      sx={{
        mt: 5,
        minHeight: "90vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: { xs: "90%", sm: "70%", lg: "40%" }, // control exact paper width
          maxWidth: "800px", // optional: limit max width
          p: 4,
          borderRadius: 3,
          backgroundColor: theme.background,
          boxShadow:
            themeMode === "light"
              ? "0 4px 16px rgba(0, 0, 0, 0.2)"
              : "0 4px 16px rgba(255, 255, 255, 0.1)",
        }}
      >


        <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ color: theme.text }}>
          Change Password
        </Typography>

        <Box
          sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}
        >
          <TextField
            label="Current Password"
            name="currentPassword"
            type="password"
            fullWidth
            required
            value={form.currentPassword}
            onChange={handleChange}
            error={Boolean(errors.currentPassword)}
            helperText={errors.currentPassword}
            sx={{
              // mb: 3,
              input: {
                color: theme.text,
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text,
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color,
                },
              },
            }}
          />

          <TextField
            label="New Password"
            name="newPassword"
            type="password"
            fullWidth
            required
            value={form.newPassword}
            onChange={handleChange}
            error={Boolean(errors.newPassword)}
            helperText={errors.newPassword}
            sx={{
              // mb: 3,
              input: {
                color: theme.text,
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text,
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color,
                },
              },
            }}
          />

          <TextField
            label="Confirm New Password"
            name="confirmPassword"
            type="password"
            fullWidth
            required
            value={form.confirmPassword}
            onChange={handleChange}
            error={Boolean(errors.confirmPassword)}
            helperText={errors.confirmPassword}
            sx={{
              // mb: 3,
              input: {
                color: theme.text,
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text,
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color,
                },
              },
            }}
          />
          <GradientButton text="Update Password"
            width="100%"
            onClick={handleSubmit}
          />
          {/* <Button type="submit" variant="contained" size="large" sx={{ borderRadius: 2 }}>
            Update Password
          </Button> */}

          {successMessage && (
            <Typography variant="body2" color="success.main" sx={{ mt: 1 }}>
              {successMessage}
            </Typography>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default ChangePassword;
